import { render, staticRenderFns } from "./materialList.vue?vue&type=template&id=7de6e096&scoped=true&"
import script from "./materialList.vue?vue&type=script&lang=js&"
export * from "./materialList.vue?vue&type=script&lang=js&"
import style0 from "./materialList.vue?vue&type=style&index=0&id=7de6e096&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de6e096",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7de6e096')) {
      api.createRecord('7de6e096', component.options)
    } else {
      api.reload('7de6e096', component.options)
    }
    module.hot.accept("./materialList.vue?vue&type=template&id=7de6e096&scoped=true&", function () {
      api.rerender('7de6e096', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DesignEditor/component/modular/materialList.vue"
export default component.exports